// Components==============
import React from 'react';
import './NoActivity.module.scss';
import { useTranslate } from 'hooks/useTranslate';
import { motion } from 'framer-motion';
import { framerFade } from 'utilities/FramerAnimations';
// =========================

export default function NoActivity({
  notContributed,
}: {
  notContributed: boolean;
}) {
  const translate = useTranslate();

  return (
    <motion.div styleName="no-activity" {...framerFade}>
      <p>
        <strong>
          {translate(
            `reflection.${
              !notContributed
                ? 'student-not-reflected'
                : 'no-activity-done-title'
            }`
          )}
        </strong>
      </p>
      {!!notContributed && (
        <p styleName="description">
          {translate('reflection.no-activity-done-description')}
        </p>
      )}
    </motion.div>
  );
}
